<template>
    <layout> 
        <template v-slot:cards>
            <div class="shell">
                <div class="cards">
                    <a 
                      v-for="(portal ,i) in portals" 
                      :class="['card', `accent-${portal.accent}`, 'mb-3']"
                      :style="{ animationDelay: `${0.22 + i * 0.08}s` }"
                      :key="portal.title"
                      :href="portal.href"
                      target="_blank"
                      rel="noopener"  
                    >
                      <div class="card-top d-flex">
                        <span class="icon-badge">
                          <v-icon size="22">
                            {{ portal.icon }}
                          </v-icon>
                        </span>
                        <span class="d-flex align-center">{{ portal.title }}</span>
                        <span class="arrow">
                            <v-icon size="14">
                                mdi-arrow-top-right
                            </v-icon>
                        </span>
                      </div>
                    </a>
                  </div>
            </div>
        </template>

    </layout>
</template>

<script>
import Layout from './layouts/Background';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import axios from 'axios';

export default {
    name: 'LoginTermReports',
    components: {
        Layout
    },
    data: () => ({
        formData: {
            name: '',
            password: '',            
        },
        show: false,        
        password: true,
        portals: [
            {
                title: 'Staff Portal',
                subtitle: 'Employee access portal',
                href: '/staff/login',
                icon: 'mdi-account-group-outline',
                accent: 'navy'
            },
            {
                title: 'Student Portal',
                subtitle: 'Parents & students access',
                href: 'https://ereport-ewss.ttschoolnet.org/',
                icon: 'mdi-file-document-outline',
                accent: 'green'
            },
            // {
            //     title: 'Registration',
            //     subtitle: 'Student registration',
            //     // href: 'https://student-registration-preysalsecondary.ttschoolnet.com',
            //     href: '#',
            //     icon: 'mdi-account-plus-outline',
            //     accent: 'gold'
            // }
        ]
    }),

    computed: {
        ...mapGetters({            
            authenticated: 'auth/getAuthenticated',
            resetPassword: 'auth/getResetPassword',                       
        }),        
       
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn', 
            employee: 'auth/employee',
            getUser: 'auth/user',
            getUserPermissionList: 'app/getUserPermissionList',
            setAuthenticated: 'auth/setAuthenticated',
            userPermissions: 'auth/userPermissions',
            serverError: 'auth/serverError',          
        }),

        ...mapMutations({
            loginError: 'auth/setLoginErrors', 
            setOverlay: 'auth/setOverlay',
            setUserName: 'auth/setUserName',
            setResetPassword: 'auth/setResetPassword',
            setPermissions: 'auth/setPermissions',
            setEmployeeId: 'auth/setEmployeeId',
            setCredentials: 'auth/setCredentials',
            setAuthenticated: 'auth/setAuthenticated',
            setEmployeeSignedIn: 'auth/setEmployeeSignedIn',
            setEmployeeInitials: 'auth/setEmployeeInitials',
            setUser: 'auth/setUser',
            setAuthToken: 'auth/setAuthToken',   

        }),

        async submit () {
            console.log('Authenticating...');
            this.setOverlay(true);
            this.setCredentials(this.formData); 
            this.setUserName(this.formData.name);
            try {
                const { data } = await this.signIn();
                console.log('data: ', data);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.auth_token;
                this.setAuthToken(data.auth_token);
                sessionStorage.setItem('auth_token', data.auth_token);
                sessionStorage.authenticated = data.name;
                sessionStorage.employeeId = data.employee_id ? data.employee_id : data.name;
                
                const user =  {
                    employee_id: data.employee_id ? data.employee_id : data.name
                }
                this.setUser(JSON.stringify(user));
                sessionStorage.setItem('user', JSON.stringify(user));
                console.log('Authenticated.')                
                this.setAuthenticated(true);
                this.loginError('');                
                
                if(data.name !== 'Admin'){
                    sessionStorage.setItem('employeeSignedIn', data.first_name + ' ' + data.last_name);
                    sessionStorage.setItem('employeeInitials', data.first_name[0] + data.last_name[0])                
                    
                    this.setEmployeeId(data.employee_id);
                    this.setEmployeeSignedIn(data.first_name + ' ' + data.last_name);
                    this.setEmployeeInitials(data.first_name[0] + data.last_name[0]);

                    const { data: dataPermissions } = await this.userPermissions();
                    sessionStorage.setItem('permissions', JSON.stringify(dataPermissions));
                    
                    if(this.resetPassword == 1){
                        this.setOverlay(false);  
                        return;                 
                    }
                }

                this.$router.replace('/app');

            } catch (error) {
                if(error.response) {
                    console.log(error.response)
                    this.loginError(error.response.data.message);
                }
                else console.log(error);
                this.serverError(error);
                
            } finally {
                this.setOverlay(false);
            }
        },
        
        keyPress (e) {
            if(e.keyCode === 13){
                //
            }
        },
        
    },
}
</script>

<style scoped>
    .v-input.portal-login__input{
    border: 1px solid rgba(245, 241, 230, 0.18);
    background: rgba(245, 241, 230, 0.06);
    border: 1px solid rgba(245, 241, 230, 0.18);
    border-radius: 10px;
    font-size: 14.5px;
    }

    .portal-login__error {
    margin: 0;
    font-size: 12.5px;
    color: #e2a0a0;
    }

    .shell {
    --ice: #e5fafb;
    --ink: #000238;
    --navy: #1B2142;
    --navy-soft: #2C3568;
    --gold: #C9982F;
    --green: #3D7A5C;
    --cream: #FAF6EF;
    --cream-deep: #F1EADC;
    --white: #FFFFFF;
    --ink: #1B2142;
    --ink-muted: #716C62;
    --shadow: 0 1px 2px rgba(27, 33, 66, 0.04), 0 12px 32px -12px rgba(27, 33, 66, 0.18);
    --shadow-hover: 0 1px 2px rgba(27, 33, 66, 0.06), 0 24px 48px -16px rgba(27, 33, 66, 0.28);

    /* min-height: 100vh; */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    /* background: #d5e0f8; */
    font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
    /* padding: 32px; */
    box-sizing: border-box;
    }

    /* ---------- portal cards ---------- */
    .cards {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: right;
    width: 300px;
    }

.card {
  position: relative;
  display: block;
  text-decoration: none;
  color: inherit;
  background: var(--white);
  border-radius: 18px;
  padding: 10px 10px 10px;
  box-shadow: var(--shadow);
  border: 1px solid rgba(27, 33, 66, 0.06);
  transition: transform 0.35s cubic-bezier(.22, 1, .36, 1), box-shadow 0.35s cubic-bezier(.22, 1, .36, 1), border-color 0.35s;
  animation: rise 0.7s cubic-bezier(.22, 1, .36, 1) both;
  overflow: hidden;
}

.card::before {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 3px;
  background: var(--accent, var(--gold));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s cubic-bezier(.22, 1, .36, 1);
}

.card:hover, .card:focus-visible {
  transform: translateY(-6px);
  box-shadow: var(--shadow-hover);
  border-color: rgba(27, 33, 66, 0.1);
  outline: none;
}
.card:hover::before, .card:focus-visible::before { transform: scaleX(1); }

.card-top { display: flex; align-items: flex-start; justify-content: space-between; }

.icon-badge {
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--accent, var(--gold)) 14%, white);
  color: var(--accent, var(--gold));
  transition: transform 0.35s cubic-bezier(.22, 1, .36, 1);
}
.card:hover .icon-badge { transform: scale(1.07) rotate(-4deg); }

.arrow {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-muted);
  background: var(--cream-deep);
  transition: transform 0.35s cubic-bezier(.22, 1, .36, 1), color 0.35s, background 0.35s;
}
.card:hover .arrow {
  transform: translate(3px, -3px);
  color: var(--white);
  background: var(--accent, var(--gold));
}

.card h2 {
  margin: 20px 0 4px;
  font-family: 'Fraunces', serif;
  font-weight: 600;
  font-size: 19px;
  color: var(--navy);
}
.card p { margin: 0; font-size: 13.5px; color: var(--ink-muted); line-height: 1.45; }

.accent-navy { --accent: var(--navy-soft); }
.accent-green { --accent: var(--green); }
.accent-gold { --accent: var(--gold); }

@keyframes rise {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .portal-page * { animation: none !important; transition: none !important; }
}

@media (max-width: 760px) {
  .cards { grid-template-columns: 1fr; }
  .portal-page { padding: 48px 20px; }
  .crest-wrap { width: 136px; height: 136px; }
  .crest-wrap img { width: 100px; }
}

/* ---------- Responsive ---------- */
@media (max-width: 780px) {
  .login-card {
    flex-direction: column-reverse;
    border-radius: 20px;
  }

  .panel-brand {
    min-height: 220px;
  }

  .logo-wrap {
    width: 130px;
    height: 130px;
  }

  .panel-form {
    padding: 32px 28px;
  }

  .signup-row {
    justify-content: center;
  }
}
</style>